import axios from "axios";
import store from "@store/index";
import router from "@/router";
import _ from 'lodash';

export const baseURL = process.env.VUE_APP_API_URL;

const api = () => {
  let token = store.getters.getAccessToken() || "";
  let api = axios.create({
    baseURL,
    headers: {
      "Accept-Language": navigator.language || navigator.userLanguage,
      Authorization: `Bearer ${token}`,
      Accept: "application/json"
    }
  });

  api.interceptors.request.use(
    conf => {
      // store.dispatch("loading/start");
      return Promise.resolve(conf);
    },
    error => {
      return Promise.reject(error);
    }
  );

  api.interceptors.response.use(
    conf => {
      // store.dispatch("loading/stop");
      return Promise.resolve(conf);
    },
    error => {
      try {
        if (
          (
            process.env.NODE_ENV !== "production" &&
            error.response.data.message
          ) ||
          (
            error.response.status == 422 &&
            error.response.data.message
          )
        ) {
          if (!error.response.data.errors) {
            store.dispatch("showNotification", {
              time: 5000,
              title: "Erro",
              text: error.response.data.message,
              color: "danger",
              iconPack: "feather",
              icon: "icon-alert-circle",
              position: "bottom-center"
            });
          }
          for (let key in error.response.data.errors) {
            error.response.data.errors[key].map(error => {
              setTimeout(
                () =>
                  store.dispatch("showNotification", {
                    time: 5000,
                    title: "Erro",
                    text: error,
                    color: "danger",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    position: "bottom-center"
                  }),
                1
              );
            });
          }
        }
      } catch (error) {
        //
      }

      if (error.response.status == 403) {
        router.replace("/");
      }

      if (error.response.status == 401) {
        if (store.getters.getAccessToken()) {
          store.dispatch("showNotification", {
            time: 5000,
            title: "Erro",
            text: "Sua sessão expirou, faça login novamente",
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-center"
          });
        }

        store.dispatch("LOGOUT");
      }

      return Promise.reject(error);
    }
  );

  return api;
};

export default api;
